import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material/material.module';
import { LoadingComponent } from './components/loading/loading.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IndeterminateCheckboxComponent } from './components/indeterminate-checkbox/indeterminate-checkbox.component';
import { BaseCardComponent } from '../../ui/base-card/base-card.component';
import { UploadItemComponent } from './components/upload-asset/upload-item/upload-item.component';
import { UploadAssetComponent } from './components/upload-asset/upload-asset.component';
import { DndDirective } from './directives/dnd-directive';
import { HeaderComponent } from './components/header/header.component';
import {
  NgbAccordionBody,
  NgbAccordionCollapse,
  NgbAccordionDirective,
  NgbAccordionItem,
  NgbCollapse,
  NgbDatepicker,
  NgbDatepickerMonth,
  NgbDropdown,
  NgbDropdownAnchor,
  NgbDropdownItem,
  NgbDropdownMenu,
  NgbDropdownToggle,
  NgbPopover,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
import { BreadcrumbsComponent } from '../../ui/breadcrumbs/breadcrumbs.component';
import { DropDownComponent } from './components/drop-down/drop-down.component';
import { NgxPopperjsModule } from 'ngx-popperjs';
import { ThrottleClickDirective } from './directives/throttle-click.directive';
import { ReactiveFormModule } from '@csspension/reactive-form';
import { LookAheadItemComponent } from './components/search-with-look-ahead/look-ahead-list/look-ahead-item/look-ahead-item.component';
import { LookAheadListComponent } from './components/search-with-look-ahead/look-ahead-list/look-ahead-list.component';
import { BackButtonComponent } from './components/back-button/back-button.component';
import { NotNullPipe } from './pipes/not-null.pipe';
import { CloseButtonComponent } from './components/close-button/close-button.component';
import { LogoComponent } from './components/logo/logo.component';
import { CustomToastComponent } from './components/custom-toast/custom-toast.component';
import { BaseActionModalComponent } from './modals/base-action-modal/base-action-modal.component';
import { ReactiveButtonsModule } from '@csspension/reactive-buttons';
import { IconButtonComponent } from './components/icon-button/icon-button.component';
import { TrustAsHtmlPipe } from './pipes/trust-as-html-pipe';
import { SlidingWindowComponent } from '../../ui/sliding-window/sliding-window.component';
import { SlidingWindowHeaderComponent } from '../../ui/sliding-window/sliding-window-header/sliding-window-header.component';
import { SlidingWindowFooterComponent } from '../../ui/sliding-window/sliding-window-footer/sliding-window-footer.component';
import { PillComponent } from '../../ui/pills/pill/pill.component';
import { TableOverlayLoadingComponent } from './components/table-overlay-loading/table-overlay-loading.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { TabBarComponent } from './components/tab-bar/tab-bar.component';
import { TabContentComponent } from './components/tab-bar/tab-content/tab-content.component';
import { EulaModalComponent } from './modals/eula-modal/eula-modal.component';
import { EulaRequiredValidatorDirective } from './directives/eula-required-validator-directive';
import { ApplicationProgressItemComponent } from './components/application-progress-item/application-progress-item.component';
import { ChangeUserEmailModalComponent } from './modals/change-user-email-modal/change-user-email-modal.component';
import { FakeCheckBoxComponent } from './components/fake-check-box/fake-check-box.component';
import { TableColumnSearchBarComponent } from './components/table-column-search-bar/table-column-search-bar.component';
import { StatusPillComponent } from './components/status-pill/status-pill.component';
import { UserProfileBadgeComponent } from './components/user-profile-badge/user-profile-badge.component';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { DashboardHeaderComponent } from './components/dashboard-header/dashboard-header.component';
import { ReorderModalComponent } from './modals/reorder-modal/reorder-modal.component';
import { ReorderListComponent } from './components/reorder-list/reorder-list.component';
import { ReorderListItemComponent } from './components/reorder-list-item/reorder-list-item.component';
import { TableColumnDropDownBarComponent } from './components/table-column-drop-down-bar/table-column-drop-down-bar.component';
import { OdataTypeaheadSearchComponent } from './components/odata-typeahead-search/odata-typeahead-search.component';
import { ProfileLookAheadItemComponent } from './components/search-with-look-ahead/look-ahead-list/look-ahead-item/profile-look-ahead-item/profile-look-ahead-item.component';
import { SearchableModalComponent } from './modals/searchable-modal/searchable-modal.component';
import { SubmissionPermissionCheckboxTableComponent } from './components/submission-permission-checkbox-table/submission-permission-checkbox-table.component';
import { MaskSinNumberPipe } from './pipes/mask-sin-number.pipe';
import { DateValidDirective } from './directives/date-valid-directive.directive';
import { DateValidAndBeforeDirective } from './directives/date-valid-and-before-directive';
import { AlertComponent } from './components/alert/alert.component';
import { CardAlertComponent } from './components/alert/components/card-alert/card-alert.component';
import { BannerAlertComponent } from './components/alert/components/banner-alert/banner-alert.component';
import { IsCardTypeAlertPipe } from './components/alert/pipes/is-card-type-alert.pipe';
import { IsBannerTypeAlertPipe } from './components/alert/pipes/is-banner-type-alert.pipe';
import { StartEndDateValidatorDirective } from './directives/start-end-date-validator.directive';
import { NameChangeSubmissionFormComponent } from './components/name-change-submission-form/name-change-submission-form.component';
import { UpdateContactInfoSubmissionFormComponent } from './components/update-contact-info-submission-form/update-contact-info-submission-form.component';
import { HeaderContainerComponent } from './components/header-container/header-container.component';
import { EntryFirstCurrencySymbolPipe } from '../../pipes/entry-currency.pipe';
import { RouterLink } from '@angular/router';
import { LabeledListItemComponent } from './components/labeled-list-item/labeled-list-item.component';
import { HistoryItemComponent } from './components/history-item/history-item.component';
import { DateStringWithAtPipe } from './components/history-item/history-item-date-string.pipe';
import { EntryCodeNamePipe } from './pipes/entry-code-name.pipe';
import { PersonalInfoSubmissionFormComponent } from './components/personal-info-submission-form/personal-info-submission-form.component';
import { BreadcrumbHeaderComponent } from './components/breadcrumb-header/breadcrumb-header.component';
import { TableOverlayBufferComponent } from './components/table-overlay-buffer/table-overlay-buffer.component';
import { EditButtonComponent } from './components/edit-button/edit-button.component';
import { MonthNamePipe } from './pipes/month-name.pipe';
import { ViewRowsDropdownComponent } from '../../ui/tables/view-rows-dropdown/view-rows-dropdown.component';
import { FileUploaderTextComponent } from './components/form-components/file-uploader/file-uploader-text/file-uploader-text.component';
import { ExistingSubmissionBannerComponent } from './components/existing-submission-banner/existing-submission-banner.component';
import { PortalTypePipe } from './pipes/portal-type.pipe';
import { FormattedDateStringInCSTPipe } from '../../pipes/formatted-date-string-in-cst.pipe';
import { DateInFutureValidatorDirective } from './directives/date-in-future-validator.directive';
import { VersionNumberExistsValidatorDirective } from './directives/version-number-exists-validator.directive';
import { VersionNumberFormatValidatorDirective } from './directives/version-number-format-validator.directive';
import { ReleaseNoteModalComponent } from './components/release-note-modal/release-note-modal.component';
import { EmployerSearchInputComponent } from './components/employer-search-input/employer-search-input.component';
import { UniqueEmailValidatorDirective } from './directives/unique-email-validator.directive';
import { LoadingShimmerModule } from 'loading-shimmer';
import { CurrentFormattedDateTimePipe } from './pipes/current-formatted-date-time.pipe';
import { RequiredCustomMessageValidatorDirective } from './directives/required-custom-message-validator.directive';
import { LeadingZeroPipe } from './pipes/leading-zero.pipe';
import { DataLabelComponent } from './components/data-label/data-label.component';
import { StepperComponent } from './components/stepper/stepper.component';
import { PrimaryButtonComponent } from './components/primary-button/primary-button.component';
import { SecondaryButtonComponent } from './components/secondary-button/secondary-button.component';
import { TertiaryButtonComponent } from './components/tertiary-button/tertiary-button.component';
import { HumanReadablePipe } from './pipes/human-readable.pipe';
import { CurrentFormattedDatePipe } from './pipes/current-formatted-date.pipe';
import { SimplePillComponent } from './components/simple-pill/simple-pill.component';
import { SetHasPipe } from './pipes/set-has.pipe';
import { CurrencySpacePipe } from './pipes/currency-space.pipe';
import { StickyFooterComponent } from './components/sticky-footer/sticky-footer.component';
import { PrimaryBackButtonComponent } from './components/primary-back-button/primary-back-button.component';
import { MemberSearchComponent } from './components/member-search/member-search.component';
import { MemberSearchInputComponent } from './components/member-search-input/member-search-input.component';
import { LabeledListSinItemComponent } from './components/labeled-list-sin-item/labeled-list-sin-item.component';
import { SystemBannerComponent } from './components/system-banner/system-banner.component';
import { SystemBannerIconPipe } from './components/system-banner/system-banner-icon.pipe';
import { SlidingWindowCommentsAndHistoryComponent } from './components/sliding-window-comments-and-history/sliding-window-comments-and-history.component';
import { SlidingWindowHistoryTabComponent } from './components/sliding-window-comments-and-history/sliding-window-history-tab/sliding-window-history-tab.component';
import { SlidingWindowCommentsTabComponent } from './components/sliding-window-comments-and-history/sliding-window-comments-tab/sliding-window-comments-tab.component';
import { CommentsFormComponent } from './components/comments-form/comments-form.component';
import { SlidingWindowCommentsComponent } from './components/sliding-window-comments/sliding-window-comments.component';
import { FilterSectionHeaderComponent } from './components/filter-section-header/filter-section-header.component';
import { ChipComponent } from './components/chip/chip.component';
import { IncludesPipe } from './pipes/includes.pipe';
import { SystemBannerDismissIconPipe } from './components/system-banner/system-banner-dismiss-icon.pipe';
import { PillRadioContainerComponent } from './components/pill-radio-container/pill-radio-container.component';
import { RepeatDirective } from './directives/repeat.directive';
import { JoinPipe } from './pipes/join.pipe';
import { DonutChartComponent } from './components/donut-chart/donut-chart.component';
import { DonutChartLegendComponent } from './components/donut-chart/donut-chart-legend/donut-chart-legend.component';
import { DonutChartWithLegendComponent } from './components/donut-chart/donut-chart-with-legend/donut-chart-with-legend.component';
import { BreadcrumbContentHeaderComponent } from '../../ui/headers/breadcrumb-content-header/breadcrumb-content-header.component';
import { ActionCardComponent } from './components/action-card/action-card.component';
import { InvestmentInstructionsCardComponent } from './components/investment-instructions-card/investment-instructions-card.component';
import { InvestmentInstructionFundColourPipe } from './components/investment-instructions-card/investment-instruction-fund-colour.pipe';
import { CheckboxInputComponent } from '../../ui/form-components/checkbox-input/checkbox-input.component';
import { CurrencyInputComponent } from '../../ui/form-components/currency-input/currency-input.component';
import { FormOptionLabelComponent } from './components/form-components/form-option-label/form-option-label.component';
import { NumericInputComponent } from './components/form-components/numeric-input/numeric-input.component';
import { PercentageInputComponent } from '../../ui/form-components/percentage-input/percentage-input.component';
import { PillPickerInputComponent } from './components/form-components/pill-picker-input/pill-picker-input.component';
import { RadioButtonInputComponent } from '../../ui/form-components/radio-button-input/radio-button-input.component';
import { ToggleSwitchInputComponent } from './components/form-components/toggle-switch-input/toggle-switch-input.component';
import { MaskitoDirective } from '@maskito/angular';
import { ChangeInvestmentInstructionsSubmissionFormComponent } from './components/change-investment-instructions-submission-form/change-investment-instructions-submission-form.component';
import { DropdownInputComponent } from './components/form-components/dropdown-input/dropdown-input.component';
import { IPAffectedAccountsCardComponent } from '../settings/components/shared/ip-affected-accounts-card/ip-affected-accounts-card.component';
import { AffectedAccountComponent } from '../settings/components/shared/affected-account/affected-account.component';
import { ButtonToggleComponent } from './components/button-toggle/button-toggle.component';
import { FileUploadFieldComponent } from './components/form-components/file-uploader/file-upload-field/file-upload-field.component';
import { FileUploadInputComponent } from './components/form-components/file-uploader/file-upload-input/file-upload-input.component';
import { CommentComponent } from '../../ui/comment/comment.component';
import { MobileNumericSearchInputComponent } from './components/mobile-numeric-search-input/mobile-numeric-search-input.component';
import { InvestmentInstructionsVisualizationComponent } from './components/investment-instructions-visualization/investment-instructions-visualization.component';
import { FundAllocationVisualizationComponent } from '../accounts/shared/components/fund-allocation-visualization/fund-allocation-visualization.component';
import { FixedDecimalPipe } from './pipes/fixed-decimal.pipe';
import { InvestmentInstructionSubmissionInstructionChangesComponent } from './components/investment-instruction-submission-instruction-changes/investment-instruction-submission-instruction-changes.component';
import { InvestmentInstructionSubmissionAllocationChangesComponent } from './components/investment-instruction-submission-allocation-changes/investment-instruction-submission-allocation-changes.component';
import { SubmissionStatusDateStringPipe } from './pipes/submission-status-date-string.pipe';
import { EllipsisPipe } from './pipes/ellipsis.pipe';
import { DateInputComponent } from './components/form-components/date-input/date-input.component';
import { TypeaheadDropdownInputComponent } from './components/form-components/typeahead-dropdown-input/typeahead-dropdown-input.component';
import { TableHeaderTextInputComponent } from '../../ui/tables/table-column-inputs/table-header-text-input/table-header-text-input.component';
import { TableHeaderNumberInputComponent } from '../../ui/tables/table-column-inputs/table-header-number-input/table-header-number-input.component';
import { TableHeaderDateInputComponent } from '../../ui/tables/table-column-inputs/table-header-date-input/table-header-date-input.component';
import { TableHeaderSelectInputComponent } from '../../ui/tables/table-column-inputs/table-header-select-input/table-header-select-input.component';
import { TextInputComponent } from '../../ui/form-components/text-input/text-input.component';
import { InternationalAddressFormGridComponent } from '../../ui/form-grids/international-address-form-grid/international-address-form-grid.component';
import { SearchInputComponent } from '../../ui/form-components/search-input/search-input.component';
import { DatepickerInputComponent } from './components/form-components/datepicker-input/datepicker-input.component';
import { DatepickerInputCalendarComponent } from './components/form-components/datepicker-input/datepicker-input-calendar/datepicker-input-calendar.component';
import { FormErrorComponent } from './components/form-components/form-error/form-error.component';
import { GetMonthNamePipe } from './pipes/get-month-name.pipe';
import { RelationshipStatusEffectiveDateLabelPipe } from './pipes/relationship-status-effective-date-label.pipe';
import { SpousePersonalInformationFormComponent } from './components/spouse-personal-information-form/spouse-personal-information-form.component';
import { SINInputComponent } from './components/form-components/sin-input/sin-input.component';
import { SpouseContactDetailsFormComponent } from './components/spouse-contact-details-form/spouse-contact-details-form.component';
import { EmailInputComponent } from './components/form-components/email-input/email-input.component';
import { PhoneCountryCodeComponent } from './components/form-components/phone-country-code/phone-country-code.component';
import { PhoneCountryCodeDropdownInputComponent } from './components/form-components/phone-country-code/country-code-dropdown-input/phone-country-code-dropdown-input.component';
import { PhoneCountryCodeNumberInputComponent } from './components/form-components/phone-country-code/phone-number-input/phone-country-code-number-input.component';
import { SpouseInformationRadioButtonsComponent } from './components/spouse-information-radio-buttons/spouse-information-radio-buttons.component';
import { BaseLoadingButtonModalComponent } from './modals/base-loading-button-modal/base-loading-button-modal.component';
import { FileSizeStringPipe } from './pipes/file-size-string.pipe';
import { MemberRelationshipStatusDetailsComponent } from './components/member-relationship-status-details/member-relationship-status-details.component';
import { ReviewEntryComponent } from './components/review-components/review-entry/review-entry.component';
import { RelationshipEffectiveDateReviewEntryComponent } from './components/review-components/relationship-effective-date-review-entry/relationship-effective-date-review-entry.component';
import { MemberSpouseInformationDetailsComponent } from './components/member-spouse-information-details/member-spouse-information-details.component';
import { SinReviewEntryComponent } from './components/review-components/sin-review-entry/sin-review-entry.component';
import { RelationshipStatusChangesComponent } from './components/relationship-status-submission-details-components/relationship-status-changes/relationship-status-changes.component';
import { SpouseContactDetailsChangesComponent } from './components/relationship-status-submission-details-components/spouse-contact-details-changes/spouse-contact-details-changes.component';
import { SpousePersonalInfoChangesComponent } from './components/relationship-status-submission-details-components/spouse-personal-info-changes/spouse-personal-info-changes.component';
import { CommentButtonComponent } from './components/comment-button/comment-button.component';
import { ScrollToTopButtonComponent } from './components/scroll-to-top-button/scroll-to-top-button.component';
import { BeneficiarySubmissionShareChangeComponent } from './components/beneficiary-submission-share-change/beneficiary-submission-share-change.component';
import { BeneficiarySubmissionShareChangeListComponent } from './components/beneficiary-submission-share-change-list/beneficiary-submission-share-change-list.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { BeneficiaryDetailsIndividualChangesComponent } from './components/beneficiary-details-individual-changes/beneficiary-details-individual-changes.component';
import { PreviousNotApplicablePipe } from './pipes/previous-not-applicable.pipe';
import { BeneficiaryDetailsEstateChangesComponent } from './components/beneficiary-details-estate-changes/beneficiary-details-estate-changes.component';
import { BeneficiaryDetailsOrganizationChangesComponent } from './components/beneficiary-details-organization-changes/beneficiary-details-organization-changes.component';
import { MemberPersonalInformationOnboardingModalComponent } from './components/member-personal-information-onboarding-modal/member-personal-information-onboarding-modal.component';
import { MemberOnboardingModalPersonalInformationFormComponent } from './components/member-personal-information-onboarding-modal/member-onboarding-modal-personal-information-form/member-onboarding-modal-personal-information-form.component';
import { MemberOnboardingModalContactInformationFormComponent } from './components/member-personal-information-onboarding-modal/member-onboarding-modal-contact-information-form/member-onboarding-modal-contact-information-form.component';
import { MaskedTextInputComponent } from './components/form-components/masked-text-input/masked-text-input.component';
import { PasswordInputComponent } from './components/form-components/password-input/password-input.component';
import { FormattedPhoneNumberPipe } from './pipes/formatted-phone-number.pipe';
import { SubmissionDetailGridComponent } from './components/submission-detail-grid/submission-detail-grid.component';
import { SubmissionDetailComponent } from './components/submission-detail-grid/submission-detail/submission-detail.component';
import { SinSubmissionDetailComponent } from './components/submission-detail-grid/sin-submission-detail/sin-submission-detail.component';
import { SubmissionDetailsChangesComponent } from './components/submission-details-changes/submission-details-changes.component';
import { FiduciaryTypeNamePipe } from './pipes/fiduciary-type-name.pipe';
import { TextareaInputComponent } from './components/form-components/textarea-input/textarea-input.component';
import { DateIsInThePastPipe } from './pipes/date-is-in-the-past.pipe';
import { DropdownButtonComponent } from './components/dropdown-button/dropdown-button.component';
import { MemberVerificationDetailsComponent } from './components/member-verification-details/member-verification-details.component';
import { MemberVerificationLabelItemComponent } from './components/member-verification-details/member-verification-label-item/member-verification-label-item.component';
import { ReviewTextInputComponent } from './components/review-components/inputs/review-text-input/review-text-input.component';
import { ReviewTextareaInputComponent } from './components/review-components/inputs/review-textarea-input/review-textarea-input.component';
import { ReviewMaskedDateInputComponent } from './components/review-components/inputs/review-masked-date-input/review-masked-date-input.component';
import { ReviewSinInputComponent } from './components/review-components/inputs/review-sin-input/review-sin-input.component';
import { ReviewNumberInputComponent } from './components/review-components/inputs/review-number-input/review-number-input.component';
import { ReviewDropdownInputComponent } from './components/review-components/inputs/review-dropdown-input/review-dropdown-input.component';
import { BatchAddMembersFileRequirementsComponent } from './components/batch-add-members-file-requirements/batch-add-members-file-requirements.component';
import { BatchAddMemberFileUploadComponent } from './components/batch-add-member-file-upload/batch-add-member-file-upload.component';
import { ReviewPhoneCountryCodeComponent } from './components/review-components/inputs/review-phone-country-code/review-phone-country-code.component';
import { BatchAddMembersFilePreviewModalComponent } from './components/batch-add-members-file-preview-modal/batch-add-members-file-preview-modal.component';
import { BatchAddMemberFilePreviewTableComponent } from './components/batch-add-members-file-preview-modal/batch-add-member-file-preview-table/batch-add-member-file-preview-table.component';
import { SinDisplayFieldComponent } from './components/sin-display-field/sin-display-field.component';
import { BatchAddMembersInformationTableCardComponent } from './components/batch-add-members-information-table-card/batch-add-members-information-table-card.component';
import { MemberTableTypeaheadDropdownComponent } from './components/member-table-inputs/member-table-typeahead-dropdown/member-table-typeahead-dropdown.component';
import { MemberTableEmailInputComponent } from './components/member-table-inputs/member-table-email-input/member-table-email-input.component';
import { MemberTableDateInputComponent } from './components/member-table-inputs/member-table-date-input/member-table-date-input.component';
import { MemberTableSinInputComponent } from './components/member-table-inputs/member-table-sin-input/member-table-sin-input.component';
import { MemberTableTextInputComponent } from './components/member-table-inputs/member-table-text-input/member-table-text-input';
import { FiduciarySubmissionSubmittedFileListComponent } from './components/fiduciary-submission-submitted-file-list/fiduciary-submission-submitted-file-list.component';
import { FileListItemComponent } from '../../ui/file-list-item/file-list-item.component';
import { PresignedUrlPipe } from '../../pipes/presigned-url.pipe';
import { EmploymentStatusPillPipe } from './pipes/employment-status-pill.pipe';
import { AgePipe } from './pipes/age.pipe';
import { AccountStatusPillPipe } from './pipes/account-status-pill.pipe';
import { DateIsInTheFuturePipe } from './pipes/date-is-in-the-future.pipe';
import { VariableBenefitReviewAccountDetailsComponent } from './components/variable-benefit-review-components/variable-benefit-review-account-details/variable-benefit-review-account-details.component';
import { VariableBenefitReviewDepositDetailsComponent } from './components/variable-benefit-review-components/variable-benefit-review-deposit-details/variable-benefit-review-deposit-details.component';
import { ReviewDepositDetailsDepositCardComponent } from './components/review-deposit-details-deposit-card/review-deposit-details-deposit-card.component';
import { AnnuityReviewAccountDetailsComponent } from './components/annuity-review-account-details/annuity-review-account-details.component';
import { VariableBenefitReviewWithdrawalDetailsComponent } from './components/variable-benefit-review-components/variable-benefit-review-withdrawal-details/variable-benefit-review-withdrawal-details.component';
import { VbReviewWithdrawalDetailsWithdrawalInstructionComponent } from './components/variable-benefit-review-components/variable-benefit-review-withdrawal-details/vb-review-withdrawal-details-withdrawal-instruction/vb-review-withdrawal-details-withdrawal-instruction.component';
import { VariableBenefitRecurringPaymentDetailsComponent } from './components/variable-benefit-review-components/variable-benefit-review-payment-details/variable-benefit-recurring-payment-details/variable-benefit-recurring-payment-details.component';
import { VariableBenefitRecurringPaymentDetailsCardComponent } from './components/variable-benefit-review-components/variable-benefit-review-payment-details/variable-benefit-recurring-payment-details/variable-benefit-recurring-payment-details-card/variable-benefit-recurring-payment-details-card.component';
import { VariableBenefitLumpSumPaymentDetailsComponent } from './components/variable-benefit-review-components/variable-benefit-review-payment-details/variable-benefit-lump-sum-payment-details/variable-benefit-lump-sum-payment-details.component';
import { VariableBenefitLumpSumPaymentDetailsCardComponent } from './components/variable-benefit-review-components/variable-benefit-review-payment-details/variable-benefit-lump-sum-payment-details/variable-benefit-lump-sum-payment-details-card/variable-benefit-lump-sum-payment-details-card.component';
import { RecurringPaymentAmountTypeNamePipe } from './components/variable-benefit-review-components/pipes/recurring-payment-amount-type-name.pipe';
import { RecurringPaymentFrequencyPipe } from './components/variable-benefit-review-components/pipes/recurring-payment-frequency.pipe';
import { VbPaymentStartDatePipe } from './components/variable-benefit-review-components/pipes/vb-payment-start-date.pipe';
import { FundTypeByIdPipe } from './pipes/fund-type-by-id.pipe';
import { SubmissionFileListComponent } from './components/submission-files/submission-file-list.component';
import { IpAffectedAccountCardNamePipe } from './pipes/ip-affected-account-card-name.pipe';
import { TableFilterPillsComponent } from '../../ui/tables/table-filter-pills/table-filter-pills.component';
import { TableColumnHeaderComponent } from '../../ui/tables/table-column-header/table-column-header.component';
import { TableEmptyStateComponent } from '../../ui/tables/table-empty-state/table-empty-state.component';
import { AccountingCurrencyPipe } from './pipes/accounting-currency.pipe';
import { PendingSubmissionModalCardComponent } from './components/pending-submission-modal-card/pending-submission-modal-card.component';
import { TableFooterComponent } from '../../ui/tables/table-footer/table-footer.component';
import { TablePaginatorComponent } from '../../ui/tables/table-paginator/table-paginator.component';
import { TableResultsTextComponent } from '../../ui/tables/table-results-text/table-results-text.component';
import { TableCellShimmerComponent } from '../../ui/tables/table-cell-shimmer/table-cell-shimmer.component';
import { VbScheduledChangeNoticeComponent } from './components/vb-payment-change-review-components/vb-scheduled-change-notice/vb-scheduled-change-notice.component';
import { HeadOfficeAddressFormGridComponent } from './components/form-grids/head-office-address-form-grid/head-office-address-form-grid.component';
import { MailingAddressFormGridComponent } from './components/form-grids/mailing-address-form-grid/mailing-address-form-grid.component';
import { ImageCropperModalComponent } from './components/image-cropper-modal/image-cropper-modal.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { MemberVbAccountConfigAccountDetailsCardComponent } from './components/member-vb-account-config-account-details-card/member-vb-account-config-account-details-card.component';
import { EmployerPrimaryContactFormGridComponent } from './components/form-grids/employer-primary-contact-form-grid/employer-primary-contact-form-grid.component';
import { EmployerAdditionalContactFormGridComponent } from './components/form-grids/employer-additional-contact-form-grid/employer-additional-contact-form-grid.component';
import { ReviewDatepickerInputComponent } from './components/review-components/inputs/review-datepicker-input/review-datepicker-input.component';
import { EmployerContactCardComponent } from './components/employer-contact-card/employer-contact-card.component';
import { EmployerRecordContactsSectionComponent } from './components/employer-record-contacts-section/employer-record-contacts-section.component';
import { CreateUserGeneralFormGridComponent } from './components/form-grids/create-user-general-form-grid/create-user-general-form-grid.component';
import { CreateUserAdditionalRolesFormGridComponent } from './components/form-grids/create-user-additional-roles-form-grid/create-user-additional-roles-form-grid.component';
import { EmployerRecordPrimaryContactAccordionComponent } from './components/employer-record-accordions/employer-record-primary-contact-accordion/employer-record-primary-contact-accordion.component';
import { EmployerRecordAdditionalContactAccordionComponent } from './components/employer-record-accordions/employer-record-additional-contact-accordion/employer-record-additional-contact-accordion.component';
import { EmployerRecordContactRemoveModalComponent } from './components/employer-record-contact-remove-modal/employer-record-contact-remove-modal.component';
import { EmployerRecordAddAdditionalContactModalComponent } from './components/employer-record-add-additional-contact-modal/employer-record-add-additional-contact-modal.component';
import { EmployerRecordAddPrimaryContactModalComponent } from './components/employer-record-add-primary-contact-modal/employer-record-add-primary-contact-modal.component';
import { EmployerUpdateContactSubmissionContactChangesComponent } from './components/employer-update-contact-submission-contact-changes/employer-update-contact-submission-contact-changes.component';
import { EmployerUpdateContactSubmissionContactDetailsChangesComponent } from './components/employer-update-contact-submission-contact-details-changes/employer-update-contact-submission-contact-details-changes.component';
import { EmployerContactSubmissionDetailsFieldChangeComponent } from './components/employer-contact-submission-details-field-change/employer-contact-submission-details-field-change.component';
import { SubmissionStatusLabelPipe } from './pipes/submission-status-label.pipe';
import { SubmissionStatusDatePipe } from './pipes/submission-status-date.pipe';
import { EmployerRecordOverviewCardReviewGridComponent } from './components/employer-record-overview-card-review-grid/employer-record-overview-card-review-grid.component';
import { EmployerRecordAddressesCardComponent } from './components/employer-record-addresses-card/employer-record-addresses-card.component';
import { VariableBenefitPaymentAmountsCardComponent } from './components/variable-benefit-payment-amounts-card/variable-benefit-payment-amounts-card.component';
import { IpMemberOverviewCardComponent } from './components/ip-member-overview-card/ip-member-overview-card.component';
import { EmployerContributionRemittanceComponent } from './components/employer-contributions/employer-contribution-remittance/employer-contribution-remittance.component';
import { EmployerContributionScheduledRemittanceComponent } from './components/employer-contributions/employer-contribution-scheduled-remittance/employer-contribution-scheduled-remittance.component';
import { VbPaymentsOverviewCardComponent } from './components/variable-benefit-payments-components/vb-payments-overview-card/vb-payments-overview-card.component';
import { VbPaymentsYearToDatePaymentsComponent } from './components/variable-benefit-payments-components/vb-payments-overview-details-cards/vb-payments-year-to-date-payments/vb-payments-year-to-date-payments.component';
import { VbPaymentsNextPaymentByComponent } from './components/variable-benefit-payments-components/vb-payments-overview-details-cards/vb-payments-next-payment-by/vb-payments-next-payment-by.component';
import { VbPaymentsEstimatedAnnualTotalComponent } from './components/variable-benefit-payments-components/vb-payments-overview-details-cards/vb-payments-estimated-annual-total/vb-payments-estimated-annual-total.component';
import { VbPaymentsDepositedToComponent } from './components/variable-benefit-payments-components/vb-payments-overview-details-cards/vb-payments-deposited-to/vb-payments-deposited-to.component';
import { VbPaymentsAnnualMinimumComponent } from './components/variable-benefit-payments-components/vb-payments-overview-details-cards/vb-payments-annual-minimum/vb-payments-annual-minimum.component';
import { VbPaymentsMinCalculationAgeComponent } from './components/variable-benefit-payments-components/vb-payments-overview-details-cards/vb-payments-min-calculation-age/vb-payments-min-calculation-age.component';
import { VbPaymentsRecurringPaymentDetailsCardComponent } from './components/variable-benefit-payments-components/vb-payments-recurring-payment-details-card/vb-payments-recurring-payment-details-card.component';
import { VbPaymentsRecurringPaymentCardComponent } from './components/variable-benefit-payments-components/vb-payments-recurring-payment-details-card/vb-payments-recurring-payment-card/vb-payments-recurring-payment-card.component';
import { VbPaymentsRecurringPaymentRowComponent } from './components/variable-benefit-payments-components/vb-payments-recurring-payment-details-card/vb-payments-recurring-payment-row/vb-payments-recurring-payment-row.component';
import { VbPaymentsLumpSumDetailsCardComponent } from './components/variable-benefit-payments-components/vb-payments-lump-sum-details-card/vb-payments-lump-sum-details-card.component';
import { VbPaymentsWithdrawalDetailsCardComponent } from './components/variable-benefit-payments-components/vb-payments-withdrawal-details-card/vb-payments-withdrawal-details-card.component';
import { WithdrawalInstructionsCardComponent } from './components/variable-benefit-payments-components/vb-payments-withdrawal-details-card/withdrawal-instructions-card/withdrawal-instructions-card.component';
import { VbViewUpcomingPaymentsModalComponent } from './components/variable-benefit-payments-components/vb-view-upcoming-payments-modal/vb-view-upcoming-payments-modal.component';
import { VbPaymentChangeSubmissionAccountDetailsCardComponent } from './components/vb-payment-change-review-components/vb-payment-change-submission-account-details-card/vb-payment-change-submission-account-details-card.component';
import { VbViewPastLumpSumPaymentsModalComponent } from './components/variable-benefit-payments-components/vb-view-past-lump-sum-payments-modal/vb-view-past-lump-sum-payments-modal.component';
import { VbMinimumAgePersonCardComponent } from './components/create-vb-payment-change-components/vb-minimum-age-person-card/vb-minimum-age-person-card.component';
import { VbPaymentChangeAgeForMinimumCardComponent } from './components/create-vb-payment-change-components/vb-payment-change-age-for-minimum-card/vb-payment-change-age-for-minimum-card.component';
import { VbWrittenChequeCardComponent } from '../records/components/members/ip-view-member-record/components/ip-member-record-variable-benefit-configuration/steps/variable-benefit-configuration-deposits-step/vb-written-cheque-card/vb-written-cheque-card.component';
import { BankAccountAccordionCardComponent } from '../banking/components/bank-account-accordion-card/bank-account-accordion-card.component';
import { BankAccountComponent } from '../banking/components/bank-account/bank-account.component';
import { VbWithdrawalInstructionsCardComponent } from './components/create-variable-benefit-submission-components/vb-withdrawal-instructions-card/vb-withdrawal-instructions-card.component';
import { VbWithdrawalPercentFieldComponent } from './components/create-variable-benefit-submission-components/vb-withdrawal-instructions-card/vb-withdrawal-percent-field/vb-withdrawal-percent-field.component';
import { VbWithdrawalPercentageInputLabelComponent } from './components/create-variable-benefit-submission-components/vb-withdrawal-instructions-card/vb-withdrawal-percent-field/vb-withdrawal-percentage-input-label/vb-withdrawal-percentage-input-label.component';
import { VbPaymentChangeRecurringPaymentFrequencyCardComponent } from './components/create-vb-payment-change-components/vb-payment-change-recurring-payment-frequency-card/vb-payment-change-recurring-payment-frequency-card.component';
import { VbPaymentChangeFrequencyDateStringPipe } from './components/create-vb-payment-change-components/vb-payment-change-recurring-payment-frequency-card/vb-payment-change-frequency-date-string.pipe';
import { VbPaymentChangeLumpSumPaymentCardComponent } from './components/create-vb-payment-change-components/vb-payment-change-lump-sum-payment-card/vb-payment-change-lump-sum-payment-card.component';
import { VbPaymentChangeLumpSumUpcomingCardComponent } from './components/create-vb-payment-change-components/vb-payment-change-lump-sum-payment-card/vb-payment-change-lump-sum-upcoming-card/vb-payment-change-lump-sum-upcoming-card.component';
import { VbPaymentChangeEditRecurringPaymentModalComponent } from './components/create-vb-payment-change-components/vb-payment-change-edit-recurring-payment-modal/vb-payment-change-edit-recurring-payment-modal.component';
import { VbPaymentChangeSubmissionAgeForMinimumCalculationCardComponent } from './components/vb-payment-change-review-components/vb-payment-change-submission-age-for-minimum-calculation-card/vb-payment-change-submission-age-for-minimum-calculation-card.component';
import { VbPaymentChangeDepositDetailChangeAccordionComponent } from './components/vb-payment-change-review-components/vb-payment-change-submission-deposit-details-card/vb-payment-change-deposit-detail-change-accordion/vb-payment-change-deposit-detail-change-accordion.component';
import { VbPaymentChangeSubmissionDepositDetailsCardComponent } from './components/vb-payment-change-review-components/vb-payment-change-submission-deposit-details-card/vb-payment-change-submission-deposit-details-card.component';
import { VbPaymentChangeLumpSumCardComponent } from './components/vb-payment-change-review-components/vb-payment-change-submission-lump-sum-details-card/vb-payment-change-lump-sum-card/vb-payment-change-lump-sum-card.component';
import { VbPaymentChangeSubmissionLumpSumDetailsCardComponent } from './components/vb-payment-change-review-components/vb-payment-change-submission-lump-sum-details-card/vb-payment-change-submission-lump-sum-details-card.component';
import { VbPaymentChangeRecurringPaymentFrequencyLabelPipe } from './components/vb-payment-change-review-components/vb-payment-change-submission-recurring-payments-card/vb-payment-change-recurring-payment-frequency-label.pipe';
import { VbPaymentChangeSubmissionActivePaymentComponent } from './components/vb-payment-change-review-components/vb-payment-change-submission-recurring-payments-card/vb-payment-change-submission-recurring-payment/vb-payment-change-submission-active-payment/vb-payment-change-submission-active-payment.component';
import { VbPaymentChangeSubmissionMultiplePaymentsComponent } from './components/vb-payment-change-review-components/vb-payment-change-submission-recurring-payments-card/vb-payment-change-submission-recurring-payment/vb-payment-change-submission-multiple-payments/vb-payment-change-submission-multiple-payments.component';
import { VbPaymentChangeSubmissionRecurringPaymentComponent } from './components/vb-payment-change-review-components/vb-payment-change-submission-recurring-payments-card/vb-payment-change-submission-recurring-payment/vb-payment-change-submission-recurring-payment.component';
import { VbPaymentChangeSubmissionScheduledPaymentComponent } from './components/vb-payment-change-review-components/vb-payment-change-submission-recurring-payments-card/vb-payment-change-submission-recurring-payment/vb-payment-change-submission-scheduled-payment/vb-payment-change-submission-scheduled-payment.component';
import { VbPaymentChangeSubmissionRecurringPaymentsCardComponent } from './components/vb-payment-change-review-components/vb-payment-change-submission-recurring-payments-card/vb-payment-change-submission-recurring-payments-card.component';
import { VbPaymentChangeSubmissionWithdrawalDetailsCardComponent } from './components/vb-payment-change-review-components/vb-payment-change-submission-withdrawal-details-card/vb-payment-change-submission-withdrawal-details-card.component';
import { VariableBenefitReviewConsentWaiverComponent } from './components/variable-benefit-review-components/variable-benefit-review-consent-waiver/variable-benefit-review-consent-waiver.component';
import { StatusPillReviewEntryComponent } from './components/review-components/status-pill-review-entry/status-pill-review-entry.component';
import { SortableTableColumnHeaderComponent } from './components/tables/sortable-table-column-header/sortable-table-column-header.component';
import { TypeaheadSearchInputComponent } from './components/form-components/typeahead-search-input/typeahead-search-input.component';
/*
 * ReactiveFormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' })
 * see https://github.com/angular/angular/issues/48350
 */

/*
 * ReactiveFormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' })
 * see https://github.com/angular/angular/issues/48350
 */

@NgModule({
  providers: [],
  declarations: [
    ApplicationProgressItemComponent,
    DropDownComponent,
    IndeterminateCheckboxComponent,
    UploadItemComponent,
    UploadAssetComponent,
    DateValidAndBeforeDirective,
    EulaRequiredValidatorDirective,
    HeaderComponent,
    BackButtonComponent,
    NotNullPipe,
    PortalTypePipe,
    LogoComponent,
    CustomToastComponent,
    IconButtonComponent,
    TrustAsHtmlPipe,
    ExistingSubmissionBannerComponent,
    TableOverlayLoadingComponent,
    PageHeaderComponent,
    DateInFutureValidatorDirective,
    EulaModalComponent,
    ChangeUserEmailModalComponent,
    CurrentFormattedDateTimePipe,
    FakeCheckBoxComponent,
    TableColumnSearchBarComponent,
    DashboardHeaderComponent,
    ReorderModalComponent,
    ReorderListComponent,
    ReorderListItemComponent,
    DatePickerComponent,
    TableColumnDropDownBarComponent,
    SearchableModalComponent,
    SubmissionPermissionCheckboxTableComponent,
    MaskSinNumberPipe,
    DateValidDirective,
    AlertComponent,
    CardAlertComponent,
    ReleaseNoteModalComponent,
    VersionNumberExistsValidatorDirective,
    VersionNumberFormatValidatorDirective,
    IsBannerTypeAlertPipe,
    IsCardTypeAlertPipe,
    StartEndDateValidatorDirective,
    NameChangeSubmissionFormComponent,
    UpdateContactInfoSubmissionFormComponent,
    LabeledListItemComponent,
    LabeledListSinItemComponent,
    HistoryItemComponent,
    DateStringWithAtPipe,
    EntryCodeNamePipe,
    PersonalInfoSubmissionFormComponent,
    BreadcrumbHeaderComponent,
    TableOverlayBufferComponent,
    MonthNamePipe,
    EmployerSearchInputComponent,
    UniqueEmailValidatorDirective,
    RequiredCustomMessageValidatorDirective,
    HumanReadablePipe,
    SimplePillComponent,
    CurrencySpacePipe,
    CurrentFormattedDatePipe,
    MemberSearchComponent,
    MemberSearchInputComponent,
    SlidingWindowCommentsAndHistoryComponent,
    SlidingWindowHistoryTabComponent,
    SlidingWindowCommentsTabComponent,
    JoinPipe,
    DonutChartComponent,
    DonutChartLegendComponent,
    DonutChartWithLegendComponent,
    ActionCardComponent,
    InvestmentInstructionsCardComponent,
    InvestmentInstructionFundColourPipe,
    NumericInputComponent,
    ChangeInvestmentInstructionsSubmissionFormComponent,
    IPAffectedAccountsCardComponent,
    AffectedAccountComponent,
    ButtonToggleComponent,
    MobileNumericSearchInputComponent,
    InvestmentInstructionsVisualizationComponent,
    FundAllocationVisualizationComponent,
    InvestmentInstructionSubmissionInstructionChangesComponent,
    InvestmentInstructionSubmissionAllocationChangesComponent,
    DateInputComponent,
    TypeaheadDropdownInputComponent,
    RelationshipStatusEffectiveDateLabelPipe,
    SpousePersonalInformationFormComponent,
    SpouseContactDetailsFormComponent,
    SpouseInformationRadioButtonsComponent,
    MemberRelationshipStatusDetailsComponent,
    RelationshipEffectiveDateReviewEntryComponent,
    MemberSpouseInformationDetailsComponent,
    SinReviewEntryComponent,
    RelationshipStatusChangesComponent,
    SpousePersonalInfoChangesComponent,
    SpouseContactDetailsChangesComponent,
    ScrollToTopButtonComponent,
    MemberPersonalInformationOnboardingModalComponent,
    MemberOnboardingModalPersonalInformationFormComponent,
    MemberOnboardingModalContactInformationFormComponent,
    PasswordInputComponent,
    SubmissionDetailGridComponent,
    FiduciaryTypeNamePipe,
    DateIsInThePastPipe,
    MemberVerificationDetailsComponent,
    MemberVerificationLabelItemComponent,
    ReviewMaskedDateInputComponent,
    ReviewSinInputComponent,
    ReviewNumberInputComponent,
    BatchAddMembersFileRequirementsComponent,
    BatchAddMemberFileUploadComponent,
    BatchAddMembersFilePreviewModalComponent,
    BatchAddMemberFilePreviewTableComponent,
    SinDisplayFieldComponent,
    BatchAddMembersInformationTableCardComponent,
    MemberTableTypeaheadDropdownComponent,
    MemberTableEmailInputComponent,
    MemberTableDateInputComponent,
    MemberTableSinInputComponent,
    MemberTableTextInputComponent,
    FiduciarySubmissionSubmittedFileListComponent,
    EmploymentStatusPillPipe,
    AgePipe,
    VariableBenefitReviewAccountDetailsComponent,
    VariableBenefitReviewDepositDetailsComponent,
    ReviewDepositDetailsDepositCardComponent,
    AnnuityReviewAccountDetailsComponent,
    VariableBenefitReviewWithdrawalDetailsComponent,
    VbReviewWithdrawalDetailsWithdrawalInstructionComponent,
    VariableBenefitRecurringPaymentDetailsComponent,
    VariableBenefitRecurringPaymentDetailsCardComponent,
    VariableBenefitLumpSumPaymentDetailsComponent,
    VariableBenefitLumpSumPaymentDetailsCardComponent,
    RecurringPaymentAmountTypeNamePipe,
    RecurringPaymentFrequencyPipe,
    VbPaymentStartDatePipe,
    FundTypeByIdPipe,
    IpAffectedAccountCardNamePipe,
    AccountingCurrencyPipe,
    PendingSubmissionModalCardComponent,
    HeadOfficeAddressFormGridComponent,
    MailingAddressFormGridComponent,
    ImageCropperModalComponent,
    MemberVbAccountConfigAccountDetailsCardComponent,
    EmployerPrimaryContactFormGridComponent,
    EmployerAdditionalContactFormGridComponent,
    EmployerContactCardComponent,
    EmployerRecordContactsSectionComponent,
    CreateUserGeneralFormGridComponent,
    CreateUserAdditionalRolesFormGridComponent,
    EmployerRecordPrimaryContactAccordionComponent,
    EmployerRecordAdditionalContactAccordionComponent,
    EmployerRecordContactRemoveModalComponent,
    EmployerRecordAddAdditionalContactModalComponent,
    EmployerRecordAddPrimaryContactModalComponent,
    EmployerUpdateContactSubmissionContactChangesComponent,
    EmployerUpdateContactSubmissionContactDetailsChangesComponent,
    EmployerContactSubmissionDetailsFieldChangeComponent,
    SubmissionStatusLabelPipe,
    SubmissionStatusDatePipe,
    EmployerRecordOverviewCardReviewGridComponent,
    EmployerRecordAddressesCardComponent,
    VariableBenefitPaymentAmountsCardComponent,
    IpMemberOverviewCardComponent,
    EmployerContributionRemittanceComponent,
    EmployerContributionScheduledRemittanceComponent,
    VbPaymentsOverviewCardComponent,
    VbPaymentsYearToDatePaymentsComponent,
    VbPaymentsNextPaymentByComponent,
    VbPaymentsEstimatedAnnualTotalComponent,
    VbPaymentsDepositedToComponent,
    VbPaymentsAnnualMinimumComponent,
    VbPaymentsMinCalculationAgeComponent,
    VbPaymentsRecurringPaymentDetailsCardComponent,
    VbPaymentsRecurringPaymentCardComponent,
    VbPaymentsRecurringPaymentRowComponent,
    VbPaymentsLumpSumDetailsCardComponent,
    VbPaymentsWithdrawalDetailsCardComponent,
    WithdrawalInstructionsCardComponent,
    VbViewUpcomingPaymentsModalComponent,
    VbPaymentChangeSubmissionAccountDetailsCardComponent,
    VbViewPastLumpSumPaymentsModalComponent,
    VbPaymentChangeSubmissionAgeForMinimumCalculationCardComponent,
    VbPaymentChangeSubmissionRecurringPaymentsCardComponent,
    VbPaymentChangeSubmissionRecurringPaymentComponent,
    VbPaymentChangeSubmissionActivePaymentComponent,
    VbPaymentChangeSubmissionScheduledPaymentComponent,
    VbPaymentChangeSubmissionMultiplePaymentsComponent,
    VbPaymentChangeRecurringPaymentFrequencyLabelPipe,
    VbPaymentChangeSubmissionLumpSumDetailsCardComponent,
    VbPaymentChangeLumpSumCardComponent,
    VbPaymentChangeSubmissionWithdrawalDetailsCardComponent,
    VbPaymentChangeSubmissionDepositDetailsCardComponent,
    VbPaymentChangeDepositDetailChangeAccordionComponent,
    VbWithdrawalInstructionsCardComponent,
    VbWithdrawalPercentFieldComponent,
    VbWithdrawalPercentageInputLabelComponent,
    VbMinimumAgePersonCardComponent,
    VbPaymentChangeAgeForMinimumCardComponent,
    VbPaymentChangeRecurringPaymentFrequencyCardComponent,
    VbPaymentChangeFrequencyDateStringPipe,
    VbPaymentChangeLumpSumPaymentCardComponent,
    VbPaymentChangeLumpSumUpcomingCardComponent,
    VbPaymentChangeEditRecurringPaymentModalComponent,
    VariableBenefitReviewConsentWaiverComponent,
    StatusPillReviewEntryComponent,
    SortableTableColumnHeaderComponent,
    TypeaheadSearchInputComponent,
  ],
  imports: [
    ChipComponent,
    IncludesPipe,
    DropdownButtonComponent,
    FilterSectionHeaderComponent,
    PillPickerInputComponent,
    CommentsFormComponent,
    SlidingWindowCommentsComponent,
    CommentButtonComponent,
    EmailInputComponent,
    FormattedPhoneNumberPipe,
    ReviewPhoneCountryCodeComponent,
    SINInputComponent,
    VbScheduledChangeNoticeComponent,
    StickyFooterComponent,
    DataLabelComponent,
    ReviewDatepickerInputComponent,
    BaseCardComponent,
    CommonModule,
    MaskedTextInputComponent,
    InternationalAddressFormGridComponent,
    PaginatorComponent,
    LoadingComponent,
    ProgressBarComponent,
    LookAheadItemComponent,
    LookAheadListComponent,
    OdataTypeaheadSearchComponent,
    ProfileLookAheadItemComponent,
    BeneficiarySubmissionShareChangeComponent,
    BeneficiarySubmissionShareChangeListComponent,
    SinSubmissionDetailComponent,
    BeneficiaryDetailsIndividualChangesComponent,
    BeneficiaryDetailsEstateChangesComponent,
    BeneficiaryDetailsOrganizationChangesComponent,
    FixedDecimalPipe,
    PreviousNotApplicablePipe,
    MaterialModule,
    NgxSpinnerModule,
    SearchInputComponent,
    SystemBannerComponent,
    SystemBannerIconPipe,
    SystemBannerDismissIconPipe,
    FormsModule,
    ReactiveFormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode',
    }),
    NgbTooltipModule,
    NgxPopperjsModule,
    ReactiveFormModule,
    ReactiveButtonsModule,
    NgbCollapse,
    NgbDatepicker,
    RouterLink,
    NgbDatepickerMonth,
    NgbAccordionDirective,
    NgbAccordionItem,
    NgbAccordionCollapse,
    NgbAccordionBody,
    LoadingShimmerModule,
    MaskitoDirective,
    BannerAlertComponent,
    CheckboxInputComponent,
    CurrencyInputComponent,
    PercentageInputComponent,
    TextInputComponent,
    RadioButtonInputComponent,
    BankAccountAccordionCardComponent,
    BankAccountComponent,
    VbWrittenChequeCardComponent,
    NgbPopover,
    NgbDropdown,
    NgbDropdownMenu,
    NgbDropdownItem,
    NgbDropdownToggle,
    NgbDropdownAnchor,
    ImageCropperModule,
    EditButtonComponent,
    TertiaryButtonComponent,
    PrimaryButtonComponent,
    ReviewTextInputComponent,
    ReviewTextareaInputComponent,
    ReviewDropdownInputComponent,
    FormErrorComponent,
    PhoneCountryCodeComponent,
    PhoneCountryCodeDropdownInputComponent,
    PhoneCountryCodeNumberInputComponent,
    UserProfileBadgeComponent,
    CommentComponent,
    ReviewEntryComponent,
    SubmissionDetailComponent,
    SubmissionDetailsChangesComponent,
    LeadingZeroPipe,
    DateIsInTheFuturePipe,
    AccountStatusPillPipe,
    StatusPillComponent,
    BreadcrumbsComponent,
    BreadcrumbContentHeaderComponent,
    SubmissionFileListComponent,
    FileListItemComponent,
    PresignedUrlPipe,
    FileUploadFieldComponent,
    FileUploadInputComponent,
    FileSizeStringPipe,
    FileUploaderTextComponent,
    EllipsisPipe,
    DndDirective,
    BaseActionModalComponent,
    CloseButtonComponent,
    SecondaryButtonComponent,
    ThrottleClickDirective,
    DropdownInputComponent,
    DatepickerInputComponent,
    DatepickerInputCalendarComponent,
    TextareaInputComponent,
    GetMonthNamePipe,
    BaseLoadingButtonModalComponent,
    ToggleSwitchInputComponent,
    TabBarComponent,
    TabContentComponent,
    HeaderContainerComponent,
    PillComponent,
    PillRadioContainerComponent,
    EntryFirstCurrencySymbolPipe,
    ViewRowsDropdownComponent,
    TableHeaderTextInputComponent,
    TableHeaderNumberInputComponent,
    TableHeaderDateInputComponent,
    TableHeaderSelectInputComponent,
    TableFilterPillsComponent,
    TableColumnHeaderComponent,
    TableEmptyStateComponent,
    TableFooterComponent,
    TablePaginatorComponent,
    TableResultsTextComponent,
    TableCellShimmerComponent,
    SlidingWindowComponent,
    SlidingWindowHeaderComponent,
    SlidingWindowFooterComponent,
    FormattedDateStringInCSTPipe,
    SubmissionStatusDateStringPipe,
    RepeatDirective,
    PrimaryBackButtonComponent,
    StepperComponent,
    SetHasPipe,
    FormOptionLabelComponent,
  ],
  exports: [
    // Shared Components
    InternationalAddressFormGridComponent,
    MaterialModule,
    LoadingComponent,
    NgxSpinnerModule,
    DropDownComponent,
    ProgressBarComponent,
    FormsModule,
    ReactiveFormsModule,
    IndeterminateCheckboxComponent,
    UploadItemComponent,
    UploadAssetComponent,
    HeaderComponent,
    BreadcrumbsComponent,
    ReleaseNoteModalComponent,
    ThrottleClickDirective,
    DateValidAndBeforeDirective,
    LookAheadItemComponent,
    LookAheadListComponent,
    BackButtonComponent,
    NotNullPipe,
    PortalTypePipe,
    CurrentFormattedDateTimePipe,
    BaseCardComponent,
    CloseButtonComponent,
    LogoComponent,
    BaseActionModalComponent,
    TrustAsHtmlPipe,
    FormattedDateStringInCSTPipe,
    SlidingWindowComponent,
    SlidingWindowHeaderComponent,
    SlidingWindowFooterComponent,
    IconButtonComponent,
    DateInFutureValidatorDirective,
    VersionNumberExistsValidatorDirective,
    VersionNumberFormatValidatorDirective,
    PillComponent,
    TableOverlayLoadingComponent,
    PageHeaderComponent,
    ApplicationProgressItemComponent,
    FakeCheckBoxComponent,
    TableColumnSearchBarComponent,
    StatusPillComponent,
    StepperComponent,
    UserProfileBadgeComponent,
    DashboardHeaderComponent,
    ReorderModalComponent,
    DatePickerComponent,
    TableColumnDropDownBarComponent,
    OdataTypeaheadSearchComponent,
    ExistingSubmissionBannerComponent,
    SubmissionPermissionCheckboxTableComponent,
    MaskSinNumberPipe,
    DateValidDirective,
    CardAlertComponent,
    BannerAlertComponent,
    IsBannerTypeAlertPipe,
    IsCardTypeAlertPipe,
    StartEndDateValidatorDirective,
    NameChangeSubmissionFormComponent,
    UpdateContactInfoSubmissionFormComponent,
    HeaderContainerComponent,
    EntryFirstCurrencySymbolPipe,
    LabeledListItemComponent,
    LabeledListSinItemComponent,
    HistoryItemComponent,
    DateStringWithAtPipe,
    EntryCodeNamePipe,
    PersonalInfoSubmissionFormComponent,
    BreadcrumbHeaderComponent,
    TableOverlayBufferComponent,
    ViewRowsDropdownComponent,
    EditButtonComponent,
    FileUploaderTextComponent,
    EmployerSearchInputComponent,
    LeadingZeroPipe,
    DataLabelComponent,
    PrimaryButtonComponent,
    SecondaryButtonComponent,
    TertiaryButtonComponent,
    HumanReadablePipe,
    SimplePillComponent,
    SetHasPipe,
    CurrencySpacePipe,
    StickyFooterComponent,
    CurrentFormattedDatePipe,
    MemberSearchComponent,
    MemberSearchInputComponent,
    AlertComponent,
    PrimaryBackButtonComponent,
    SystemBannerComponent,
    SlidingWindowCommentsAndHistoryComponent,
    SlidingWindowHistoryTabComponent,
    SlidingWindowCommentsTabComponent,
    CommentsFormComponent,
    SlidingWindowCommentsComponent,
    FilterSectionHeaderComponent,
    ChipComponent,
    IncludesPipe,
    PillRadioContainerComponent,
    JoinPipe,
    SearchInputComponent,
    RepeatDirective,
    BreadcrumbContentHeaderComponent,
    ActionCardComponent,
    DonutChartWithLegendComponent,
    InvestmentInstructionsCardComponent,
    InvestmentInstructionFundColourPipe,
    CurrencyInputComponent,
    NumericInputComponent,
    CheckboxInputComponent,
    FormOptionLabelComponent,
    RadioButtonInputComponent,
    ToggleSwitchInputComponent,
    PillPickerInputComponent,
    PercentageInputComponent,
    DonutChartLegendComponent,
    DonutChartComponent,
    ChangeInvestmentInstructionsSubmissionFormComponent,
    IPAffectedAccountsCardComponent,
    ButtonToggleComponent,
    FileUploadFieldComponent,
    FileUploadInputComponent,
    MobileNumericSearchInputComponent,
    DropdownInputComponent,
    CommentComponent,
    InvestmentInstructionsVisualizationComponent,
    FundAllocationVisualizationComponent,
    InvestmentInstructionSubmissionInstructionChangesComponent,
    InvestmentInstructionSubmissionAllocationChangesComponent,
    FixedDecimalPipe,
    SubmissionStatusDateStringPipe,
    DateInputComponent,
    TypeaheadDropdownInputComponent,
    TypeaheadSearchInputComponent,
    TableHeaderTextInputComponent,
    TableHeaderSelectInputComponent,
    DatepickerInputComponent,
    TableHeaderNumberInputComponent,
    TableHeaderDateInputComponent,
    FormErrorComponent,
    RelationshipStatusEffectiveDateLabelPipe,
    SINInputComponent,
    SpousePersonalInformationFormComponent,
    EmailInputComponent,
    SpouseContactDetailsFormComponent,
    PhoneCountryCodeComponent,
    PhoneCountryCodeDropdownInputComponent,
    PhoneCountryCodeNumberInputComponent,
    SpouseInformationRadioButtonsComponent,
    BaseLoadingButtonModalComponent,
    MemberRelationshipStatusDetailsComponent,
    MemberSpouseInformationDetailsComponent,
    ReviewEntryComponent,
    SinReviewEntryComponent,
    StatusPillReviewEntryComponent,
    RelationshipStatusChangesComponent,
    SpousePersonalInfoChangesComponent,
    SpouseContactDetailsChangesComponent,
    FileSizeStringPipe,
    RelationshipEffectiveDateReviewEntryComponent,
    CommentButtonComponent,
    ScrollToTopButtonComponent,
    BeneficiarySubmissionShareChangeComponent,
    BeneficiarySubmissionShareChangeListComponent,
    PaginatorComponent,
    BeneficiaryDetailsIndividualChangesComponent,
    BeneficiaryDetailsEstateChangesComponent,
    BeneficiaryDetailsOrganizationChangesComponent,
    TextInputComponent,
    MaskedTextInputComponent,
    PasswordInputComponent,
    FormattedPhoneNumberPipe,
    SubmissionDetailGridComponent,
    SubmissionDetailsChangesComponent,
    SubmissionDetailComponent,
    FiduciaryTypeNamePipe,
    TextareaInputComponent,
    DateIsInThePastPipe,
    DropdownButtonComponent,
    MemberVerificationDetailsComponent,
    MemberVerificationLabelItemComponent,
    ReviewTextInputComponent,
    ReviewTextareaInputComponent,
    ReviewMaskedDateInputComponent,
    ReviewSinInputComponent,
    ReviewNumberInputComponent,
    ReviewDatepickerInputComponent,
    ReviewDropdownInputComponent,
    BatchAddMembersFileRequirementsComponent,
    BatchAddMemberFileUploadComponent,
    ReviewPhoneCountryCodeComponent,
    SinDisplayFieldComponent,
    BatchAddMembersInformationTableCardComponent,
    MemberTableTypeaheadDropdownComponent,
    MemberTableEmailInputComponent,
    MemberTableDateInputComponent,
    MemberTableSinInputComponent,
    MemberTableTextInputComponent,
    FileListItemComponent,
    PresignedUrlPipe,
    FiduciarySubmissionSubmittedFileListComponent,
    EmploymentStatusPillPipe,
    AgePipe,
    AccountStatusPillPipe,
    DateIsInTheFuturePipe,
    VariableBenefitReviewAccountDetailsComponent,
    VariableBenefitReviewDepositDetailsComponent,
    ReviewDepositDetailsDepositCardComponent,
    AnnuityReviewAccountDetailsComponent,
    VariableBenefitReviewWithdrawalDetailsComponent,
    VbReviewWithdrawalDetailsWithdrawalInstructionComponent,
    VariableBenefitRecurringPaymentDetailsComponent,
    VariableBenefitRecurringPaymentDetailsCardComponent,
    VariableBenefitLumpSumPaymentDetailsComponent,
    VariableBenefitLumpSumPaymentDetailsCardComponent,
    RecurringPaymentAmountTypeNamePipe,
    RecurringPaymentFrequencyPipe,
    VbPaymentStartDatePipe,
    FundTypeByIdPipe,
    SubmissionFileListComponent,
    TableFilterPillsComponent,
    TableColumnHeaderComponent,
    IpAffectedAccountCardNamePipe,
    AccountingCurrencyPipe,
    TableEmptyStateComponent,
    PendingSubmissionModalCardComponent,
    TableFooterComponent,
    TableCellShimmerComponent,
    HeadOfficeAddressFormGridComponent,
    MailingAddressFormGridComponent,
    MemberVbAccountConfigAccountDetailsCardComponent,
    EmployerPrimaryContactFormGridComponent,
    EmployerAdditionalContactFormGridComponent,
    EmployerContactCardComponent,
    EmployerRecordContactsSectionComponent,
    CreateUserGeneralFormGridComponent,
    CreateUserAdditionalRolesFormGridComponent,
    EmployerRecordPrimaryContactAccordionComponent,
    EmployerRecordAdditionalContactAccordionComponent,
    EmployerRecordContactRemoveModalComponent,
    EmployerRecordAddAdditionalContactModalComponent,
    EmployerUpdateContactSubmissionContactChangesComponent,
    EmployerUpdateContactSubmissionContactDetailsChangesComponent,
    EmployerContactSubmissionDetailsFieldChangeComponent,
    SubmissionStatusLabelPipe,
    SubmissionStatusDatePipe,
    EmployerRecordOverviewCardReviewGridComponent,
    EmployerRecordAddressesCardComponent,
    VariableBenefitPaymentAmountsCardComponent,
    IpMemberOverviewCardComponent,
    EmployerContributionRemittanceComponent,
    EmployerContributionScheduledRemittanceComponent,
    VbPaymentsOverviewCardComponent,
    VbPaymentChangeSubmissionAccountDetailsCardComponent,
    VbPaymentsYearToDatePaymentsComponent,
    VbPaymentsNextPaymentByComponent,
    VbPaymentsEstimatedAnnualTotalComponent,
    VbPaymentsDepositedToComponent,
    VbPaymentsAnnualMinimumComponent,
    VbPaymentsMinCalculationAgeComponent,
    VbPaymentsWithdrawalDetailsCardComponent,
    VbPaymentsLumpSumDetailsCardComponent,
    VbPaymentsRecurringPaymentDetailsCardComponent,
    VbPaymentChangeSubmissionAgeForMinimumCalculationCardComponent,
    VbPaymentChangeSubmissionRecurringPaymentsCardComponent,
    VbPaymentChangeSubmissionLumpSumDetailsCardComponent,
    VbPaymentChangeLumpSumCardComponent,
    VbPaymentChangeSubmissionWithdrawalDetailsCardComponent,
    VbPaymentChangeSubmissionDepositDetailsCardComponent,
    VbMinimumAgePersonCardComponent,
    VbPaymentChangeAgeForMinimumCardComponent,
    BankAccountAccordionCardComponent,
    BankAccountComponent,
    VbWrittenChequeCardComponent,
    VbWithdrawalInstructionsCardComponent,
    VbWithdrawalPercentFieldComponent,
    VbWithdrawalPercentageInputLabelComponent,
    VbPaymentChangeRecurringPaymentFrequencyCardComponent,
    VbPaymentChangeFrequencyDateStringPipe,
    VbPaymentChangeLumpSumPaymentCardComponent,
    VbPaymentChangeLumpSumUpcomingCardComponent,
    VbPaymentChangeEditRecurringPaymentModalComponent,
    VariableBenefitReviewConsentWaiverComponent,
    TableResultsTextComponent,
    SortableTableColumnHeaderComponent,
    GetMonthNamePipe,
    TabBarComponent,
    TabContentComponent,
  ],
})
export class SharedModule {}
